import React from "react";
import { PINTS_EVENTS } from "./pintsEvents";
import PintsSunsetPage from "./PintsSunsetPage";

export default function OpenOutcry() {
  return <PintsSunsetPage event={PINTS_EVENTS.openOutcry} />;
}
